import { api } from './index';

const BASE_PATH = '/api/internal/service_company_audit_users';

export type ServiceCompanyAuditUser = {
  id: number;
  email: string;
  serviceCompanyId: number;
  humanCreatedAt?: string;
};

export type ServiceCompanyAuditUserForm = {
  email: string;
};

export const ServiceCompanyAuditUsersApi = {
  index(serviceCompanyId: number): Promise<Array<ServiceCompanyAuditUser>> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?service_company_id=${serviceCompanyId}`,
    }).then(response => response.data.auditUsers);
  },

  create(serviceCompanyId: number, auditUserForm: ServiceCompanyAuditUserForm): Promise<ServiceCompanyAuditUser> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { ...auditUserForm, serviceCompanyId },
    }).then(response => response.data.auditUser);
  },

  update(auditUserId: number, auditUserForm: ServiceCompanyAuditUserForm): Promise<ServiceCompanyAuditUser> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${auditUserId}`,
      data: auditUserForm,
    }).then(response => response.data.auditUser);
  },

  destroy(auditUserId: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${auditUserId}`,
    }).then(() => {});
  },
};
